/**
 * Pulls the readable part out of the API's error envelope, for the screens that render
 * a failure inline instead of letting `ApiCallingV2Service` toast it.
 *
 * Validation failures come back as an `errors` array; everything else carries a single
 * `message`.
 */
export function toDsmApiErrorMessage(error: unknown, fallback: string): string {
  const body = (error as { error?: { errors?: unknown; message?: string } } | null)?.error;

  if (Array.isArray(body?.errors) && body.errors.length) return body.errors.join(', ');

  return body?.message || fallback;
}
